import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";
import imgPatients from "../assets/images/patientsIcon.svg";
import imgSettings from "../assets/images/settingsIcon.svg";
import imgSignOut from "../assets/images/signOutIcon.svg";
import useStore from "../store/store";
import "./ClinicianMenu.scss";
import "../App.scss";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch (_error) {
    return {};
  }
};

const ClinicianMenu = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const role = localStorage.getItem("role");
  const user = getStoredUser();
  const {
    clinician,
    patient,
    fetchClinician,
    fetchPatientByID,
    setClinician,
    setPatient,
  } = useStore();
  const profile = role === "Clinician" ? clinician : patient;
  const profileImage =
    role === "Clinician" ? profile?.clinicianImage : profile?.patientImage;
  const fullName = [profile?.firstName, profile?.lastName]
    .filter(Boolean)
    .join(" ");
  const displayName = fullName || user.email || "Profile";
  const initials = fullName
    ? fullName
        .split(/\s+/)
        .map((part) => part[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : "";

  useEffect(() => {
    if (!user.profile || String(profile?._id || "") === String(user.profile)) {
      return;
    }
    if (role === "Clinician") {
      fetchClinician(user.profile);
    } else if (role === "Patient") {
      fetchPatientByID(user.profile);
    }
  }, [
    role,
    user.profile,
    profile?._id,
    fetchClinician,
    fetchPatientByID,
  ]);

  const signOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user");
    setClinician(null);
    setPatient(null);
    navigate("/signin", { replace: true });
  };

  const patientsSelected = pathname === "/" || pathname.startsWith("/patients");
  const settingsSelected = pathname === "/settings";
  const profileSelected = pathname === "/profile";

  return (
    <div style={{ minHeight: "100vh" }}>
      <div className="menu-container" style={{ height: "90%" }}>
        <div className="logo-container">
          <img src={logo} alt="Vetta Sensors" />
        </div>

        {role === "Clinician" && (
          <Link
            className={`clinician-menu-links ${
              patientsSelected ? "clinician-menu-links-selected h2" : "b1"
            }`}
            to="/patients"
          >
            <div
              className="logo menu-links-icons"
              style={{
                backgroundColor: patientsSelected ? "#FFF" : "#7D7D7D",
                WebkitMask: `url(${imgPatients}) no-repeat center`,
                mask: `url(${imgPatients}) no-repeat center`,
              }}
            />
            <div>Patients</div>
          </Link>
        )}

        <Link
          className={`clinician-menu-links ${
            settingsSelected ? "clinician-menu-links-selected h2" : "b1"
          }`}
          to="/settings"
        >
          <div
            className="logo menu-links-icons"
            style={{
              backgroundColor: settingsSelected ? "#FFF" : "#7D7D7D",
              WebkitMask: `url(${imgSettings}) no-repeat center`,
              mask: `url(${imgSettings}) no-repeat center`,
            }}
          />
          <div>Settings</div>
        </Link>

        <button
          type="button"
          className="clinician-menu-links b1 sidebarSignOut"
          onClick={signOut}
        >
          <div
            className="logo menu-links-icons"
            style={{
              backgroundColor: "#7D7D7D",
              WebkitMask: `url(${imgSignOut}) no-repeat center`,
              mask: `url(${imgSignOut}) no-repeat center`,
            }}
          />
          <div>Sign Out</div>
        </button>

        <Link
          className={`clinician-profile-link b1 ${
            profileSelected ? "clinician-menu-links-selected" : ""
          }`}
          to="/profile"
          style={{ marginTop: "auto" }}
        >
          <div className="doctor-profile">
            <div className="sidebar-profile-avatar">
              {profileImage ? (
                <img src={profileImage} alt={`${displayName} profile`} />
              ) : (
                <span aria-hidden="true">{initials}</span>
              )}
            </div>
            <div className="sidebar-profile-copy">
              <div
                className="h2 sidebar-profile-name"
                style={{ color: profileSelected ? "#FFF" : "#000" }}
              >
                {role === "Clinician" && fullName
                  ? `Dr. ${fullName}`
                  : displayName}
              </div>
              <div
                className="b2"
                style={{ color: profileSelected ? "#FFF" : "#979797" }}
              >
                {role || "Profile"}
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ClinicianMenu;
